import { Component } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

interface AboutItem {
  iconImg: string;
  titleKey?: string;
  valueKey?: string;
  labelKey?: string;
  textKey: string;
}

interface AboutStep {
  titleKey: string;
  textKey: string;
}

interface AboutPartner {
  nameKey: string;
}

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent {
  constructor(private translocoService: TranslocoService) {}

  get isAr(): boolean {
    return this.translocoService.getActiveLang() === 'ar';
  }

  stats: AboutItem[] = [
    {
      iconImg: 'assets/as/34.webp',
      valueKey: 'atw.about.stats.items.years.value',
      labelKey: 'atw.about.stats.items.years.label',
      textKey: 'atw.about.stats.items.years.text'
    },
    {
      iconImg: 'assets/as/26.webp',
      valueKey: 'atw.about.stats.items.partners.value',
      labelKey: 'atw.about.stats.items.partners.label',
      textKey: 'atw.about.stats.items.partners.text'
    },
    {
      iconImg: 'assets/as/33.webp',
      valueKey: 'atw.about.stats.items.doctors.value',
      labelKey: 'atw.about.stats.items.doctors.label',
      textKey: 'atw.about.stats.items.doctors.text'
    },
    {
      iconImg: 'assets/as/32.webp',
      valueKey: 'atw.about.stats.items.nursing.value',
      labelKey: 'atw.about.stats.items.nursing.label',
      textKey: 'atw.about.stats.items.nursing.text'
    },
    {
      iconImg: 'assets/as/31.webp',
      valueKey: 'atw.about.stats.items.engineers.value',
      labelKey: 'atw.about.stats.items.engineers.label',
      textKey: 'atw.about.stats.items.engineers.text'
    }
  ];

  values: AboutItem[] = [
    {
      iconImg: 'assets/as/8.png',
      titleKey: 'atw.about.values.items.speed.title',
      textKey: 'atw.about.values.items.speed.text'
    },
    {
      iconImg: 'assets/as/17.webp',
      titleKey: 'atw.about.values.items.accuracy.title',
      textKey: 'atw.about.values.items.accuracy.text'
    },
    {
      iconImg: 'assets/as/30.webp',
      titleKey: 'atw.about.values.items.licensing.title',
      textKey: 'atw.about.values.items.licensing.text'
    },
    {
      iconImg: 'assets/as/40.webp',
      titleKey: 'atw.about.values.items.support.title',
      textKey: 'atw.about.values.items.support.text'
    }
  ];

  services: AboutItem[] = [
    {
      iconImg: 'assets/as/2.webp',
      titleKey: 'atw.about.services.items.recruitment.title',
      textKey: 'atw.about.services.items.recruitment.text'
    },
    {
      iconImg: 'assets/as/12.webp',
      titleKey: 'atw.about.services.items.cv.title',
      textKey: 'atw.about.services.items.cv.text'
    },
    {
      iconImg: 'assets/as/27.webp',
      titleKey: 'atw.about.services.items.licenses.title',
      textKey: 'atw.about.services.items.licenses.text'
    },
    {
      iconImg: 'assets/as/39.webp',
      titleKey: 'atw.about.services.items.travel.title',
      textKey: 'atw.about.services.items.travel.text'
    }
  ];

  sectors: AboutItem[] = [
    {
      iconImg: 'assets/as/33.webp',
      titleKey: 'atw.about.sectors.items.medical.title',
      textKey: 'atw.about.sectors.items.medical.text'
    },
    {
      iconImg: 'assets/as/31.webp',
      titleKey: 'atw.about.sectors.items.engineering.title',
      textKey: 'atw.about.sectors.items.engineering.text'
    },
    {
      iconImg: 'assets/as/4.webp',
      titleKey: 'atw.about.sectors.items.business.title',
      textKey: 'atw.about.sectors.items.business.text'
    },
    {
      iconImg: 'assets/as/38.webp',
      titleKey: 'atw.about.sectors.items.tech.title',
      textKey: 'atw.about.sectors.items.tech.text'
    }
  ];

  journeySteps: AboutStep[] = [
    {
      titleKey: 'atw.about.journey.steps.step1.title',
      textKey: 'atw.about.journey.steps.step1.text'
    },
    {
      titleKey: 'atw.about.journey.steps.step2.title',
      textKey: 'atw.about.journey.steps.step2.text'
    },
    {
      titleKey: 'atw.about.journey.steps.step3.title',
      textKey: 'atw.about.journey.steps.step3.text'
    },
    {
      titleKey: 'atw.about.journey.steps.step4.title',
      textKey: 'atw.about.journey.steps.step4.text'
    },
    {
      titleKey: 'atw.about.journey.steps.step5.title',
      textKey: 'atw.about.journey.steps.step5.text'
    },
    {
      titleKey: 'atw.about.journey.steps.step6.title',
      textKey: 'atw.about.journey.steps.step6.text'
    }
  ];

  partners: AboutPartner[] = [
    { nameKey: 'atw.about.partners.items.royal' },
    { nameKey: 'atw.about.partners.items.miswak' },
    { nameKey: 'atw.about.partners.items.rajhi' },
    { nameKey: 'atw.about.partners.items.raheemi' },
    { nameKey: 'atw.about.partners.items.hokail' },
    { nameKey: 'atw.about.partners.items.maysan' },
    { nameKey: 'atw.about.partners.items.ram' },
    { nameKey: 'atw.about.partners.items.lumiere' },
    { nameKey: 'atw.about.partners.items.evan' },
    { nameKey: 'atw.about.partners.items.nim' },
    { nameKey: 'atw.about.partners.items.aria' },
    { nameKey: 'atw.about.partners.items.sanaya' }
  ];

  trackByIndex(index: number): number {
    return index;
  }
}